
import ArrowUp from "../../../assets/outline/ArrowUp.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowUpIcon({ className, dataTestid = "ArrowUpIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowUp data-testid={dataTestid} className={classes} {...rest} />
  );
}
